import React from 'react';
import { Typography, Card } from '@material-ui/core';

import { Decimal } from 'shared/components/Decimal';

import { useStyles } from './styles';

interface PriceProps {
  value: string;
  title: string;
}

const Price = (props: PriceProps) => {
  const classes = useStyles();

  const { value, title } = props;

  return (
    <Card className={classes.card}>
      <Typography className={classes.totalTitle}>{title}</Typography>
      <Typography className={classes.totalValue}>
        {value}
      </Typography>
    </Card>
  );
};

export default Price;
